import {imageUrl} from '../utils/shopify-images';

const responsiveImage = (image, imageAlt, maxWidth, lazyload = true, sizes = '', aspectRatio = 'natural') => {
  const widths = [160, 320, 480, 640, 800, 960, 1120, 1280, 1440, 1600, 1920, 2240, 2560];

  let srcset = '';

  widths.forEach((width, index) => {
    if (width > maxWidth) return;
    const src = imageUrl(image.src, width);
    if (index > 0) {
      srcset += ', ';
    }
    srcset += `${src} ${width}w`;
  });

  return `<div class="component-image__wrapper aspect-ratio aspect-ratio--${aspectRatio}">
    <img
      class="component-image__image"
      src="${imageUrl(image.src, 480)}"
      srcset="${srcset}"
      loading="${lazyload ? 'lazy' : 'eager'}"
      sizes="${sizes}"
      width="${image.width}"
      height="${image.height}"
      alt="${imageAlt}"
    />
  </div>`;
};

export default responsiveImage;
